export const initShareButton = () => {
    const shareButtons = document.querySelectorAll('[data-share-button]')

    shareButtons.forEach((btn) => {
        btn.addEventListener('click', async () => {
            if (navigator.share) {
                try {
                    await navigator.share({
                        title: document.title,
                        text: 'Bekijk deze pagina',
                        url: window.location.href
                    })
                } catch (error) {
                    // User cancelled, or sharing failed
                    console.log(error)
                }
            }
        })
    })
}
